import { withStyles, WithStyles } from "@material-ui/core/styles";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { style } from "./Toasts.styles";
import { useSnackbar } from "notistack";
import * as ToastsAction from "../../../stores/toasts/ToastsAction";

interface IToastsProps extends WithStyles<typeof style> {
}

const ToastsPure: React.FunctionComponent<IToastsProps> = ({classes}) => {

    const toasts = useSelector((state) => state.toasts.items);
    const dispatch = useDispatch();
    const {enqueueSnackbar} = useSnackbar();

    if (toasts.length === 0) {
        return null;
    }

    return (
        <div className={classes.wrapper}>
            {toasts.forEach((model) => {
                enqueueSnackbar(model.header + ": " + model.message, {variant: model.type});
                dispatch(ToastsAction.removeById(model.id));
            })}
        </div>
    );
};

export const Toasts = withStyles(style)(ToastsPure);
